export default __webpack_public_path__ + "static/media/burrito_bowl.92600bfa.jpg";